/* eslint-disable import/first,no-func-assign */
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

var SvgTrafficAttackBrowser = props => /*#__PURE__*/React.createElement("svg", _extends({}, props, {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 64 64",
  "aria-hidden": !props['aria-label'],
  focusable: "false"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.51 21.45a2.09 2.09 0 1 0 0-4.18 2.09 2.09 0 0 0 0 4.18Zm6.69 0a2.09 2.09 0 1 0 0-4.18 2.09 2.09 0 0 0 0 4.18Zm6.7 0a2.09 2.09 0 1 0 0-4.18 2.09 2.09 0 0 0 0 4.18Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M56 11.92H8l-2 2v39.87l2 2h48l2-2V13.92l-2-2Zm-2 4v6.88H10v-6.88h44ZM10 51.79v-25h44v25H10Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m41.35 31.8-2.85-2.81-6.5 6.58-6.58-6.51-2.81 2.85 6.58 6.5-6.51 6.58 2.84 2.81 6.51-6.57 6.58 6.5 2.81-2.84-6.58-6.51 6.51-6.58Z"
}));

export default SvgTrafficAttackBrowser;